import { Link } from '@tink/core/src/components/atoms/Link/Link';
import { styled } from '../../../../core/theme/styled';

export const StyledLink = styled(Link)`
  font-size: ${(props) => props.theme.sizes.small};
  color: ${(props) => props.theme.palette.black.main};
`;

export const ClickableItem = styled.button`
  font-family: ${(props) => props.theme.font.face};
  cursor: pointer;

  /* reset button styles */
  border: none;
  padding: 0;
  text-align: left;
  background-color: inherit;
  appearance: none;

  img {
    max-width: 100%;
  }
`;
